export async function reExecuteContentScripts(): Promise<void> {
  const contentScripts = chrome.runtime.getManifest().content_scripts ?? [];
  const promises = [];

  for (const cs of contentScripts) {
    const tabs = await chrome.tabs.query({ url: cs.matches });
    for (const tab of tabs) {
      if (!tab.id) {
        // unable to get tab id, skip it
        continue;
      }
      if (tab.url?.startsWith('chrome://')) {
        continue;
      }
      console.log('re-executing content scripts', { cs, tab });
      const promise = chrome.scripting
        .executeScript({
          target: { tabId: tab.id },
          files: cs.js ?? [],
        })
        .catch(reason => console.error({ tab, reason }));

      promises.push(promise);
    }
  }

  await Promise.all(promises);
}
